// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */
import React, {Children} from "react";
import type {Profile} from "./ProfilePage";
import ProfilePage from "../../containers/profile/ProfilePage";

export type ProfileProviderStateProps = {
    profile: ?Profile
}

export type ProfileProviderDispatchProps = {

}

type ProfileProviderProps = {children: any} & ProfileProviderStateProps & ProfileProviderDispatchProps;

export default function ProfileProvider(props: ProfileProviderProps) {
    return props.profile ? Children.only(props.children) : <ProfilePage/>;
}




// WEBPACK FOOTER //
// ./src/components/profile/ProfileProvider.js